import React, { FC, useMemo } from "react";
import { Typography } from "../../../Fundamentals/Typography/Typography";
import MediaBuilder, {
  IMediaBuilderProps,
} from "../../../Utility/MediaBuilder/MediaBuilder";
import getCreditCardAsset from "../getCreditCardAsset";
import { TCreditCardData } from "./CreditCardInfo.interface";

export interface ICreditCardInfoProps {
  /** Credit card information */
  cardData: TCreditCardData;
  /** Custom image or asset for square icon block */
  customCardAsset?: IMediaBuilderProps;
  /** Amount of last digits that will be shown */
  showDigits?: number;
  classes?: {
    root?: string;
  };
}

const CreditCardInfo: FC<ICreditCardInfoProps> = ({
  cardData,
  showDigits = 4,
  classes,
  customCardAsset,
}) => {
  const lastNDigits = cardData.cardNumber.slice(-Number(showDigits));
  const cardAsset: IMediaBuilderProps | null = useMemo(() => {
    if (customCardAsset) return customCardAsset;
    return getCreditCardAsset(cardData.cardType);
  }, [cardData, customCardAsset]);
  return (
    <div
      className={`d-flex ${classes?.root || ""}`}
      data-testid="CreditCardInfo"
    >
      <div
        className="
                w-32px
                h-24px
                border
                rounded-4
                bg-color-white
                d-flex
                justify-content-center
                align-items-center
                me-4
              "
      >
        {cardAsset ? <MediaBuilder {...cardAsset} /> : null}
      </div>
      <Typography variant="p-medium" classes={{ root: "text-color-blue" }}>
        **** {lastNDigits}
      </Typography>
    </div>
  );
};

export default CreditCardInfo;
